import React, { useEffect, useState } from 'react'
import { Table, DataTable, Field, Chip, Heading, LoadingFull } from '@arnsbogroup/react-voicearchive'
import { FormattedDate, FormattedTime, useIntl } from 'react-intl'
import HandoverDetails from "./components/HandoverDetails";
import messages from "./messages";
import classNames from 'classnames'
import { Full as Loading } from 'components/Loading'

const HandoverPage = ({ props }) => {
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState(true)
  const [groups, setGroups] = useState([])
  const [selectedHandoverId, setSelectedHandoverId] = useState(null)
  const Span = ({ children }) => <span>{ children }</span>
  const DateSpan = ({ children }) => <span><FormattedDate value={new Date(children * 1000)} /> <FormattedTime value={new Date(children * 1000)} /></span>
  const priorityChip = ( priority ) => (
    <Chip size="xs" state={{
      'HIGH': 'error',
      'MEDIUM': 'warning',
      'LOW': 'success',
    }[priority] ?? undefined}>
      <span>
        { priority }
      </span>
    </Chip>
  )

  useEffect(() => {
    if (!selectedHandoverId) {
      fetch(`rest/v2/handover`)
        .then((response) => response.json())
        .then((response) => {
          if (response.success) {
            setGroups(response.data)
          } else {
            toastr.error(response.errors.join(', '))
          }
          setLoading(false)
        })
        .catch((err) => {
          toastr.error(err)
          setLoading(false)
        })
    }
  }, [selectedHandoverId])

  if (loading) {
    return <Loading/>
  }

  return (
    <div className='w-full pb-4'>
      { Object.keys(groups).length > 0 ? (
        <>
          { Object.entries(groups).map(([coordinator, handovers]) => (
            <div>
              {coordinator != 'Currently active' &&
              <div className='flex space-x-8 p-4 bg-gray-200'>
                  <Field>
                    {coordinator}
                  </Field>
                  <Field>
                    ({handovers.length})
                  </Field>
              </div>
              }
        
              <DataTable
                  components={{
                    Tr: ({ childProps = {}, ...innerProps }) => {
                      return (
                        <Table.Tr
                          className={classNames({
                            'cursor-pointer': !!childProps.order,
                          })}
                          onClick={() => setSelectedHandoverId(childProps.uid)}
                        
                          {...innerProps }
                        />
                      )
                    },
                    Td: ({ childProps = {}, ...props }) => (
                      <Table.Td
                        {...props }
                      />
                    )
                  }}
                  head={{
                    deal: { sortable: true, label: formatMessage(messages.deal) },
                    customerName: { sortable: true, label: formatMessage(messages.company) },
                    priority: { sortable: true, label: formatMessage(messages.priority) },
                    deadline: { sortable: true, label: formatMessage(messages.deliveryDeadline) },
                    languageCount: { sortable: true, label: formatMessage(messages.numberOfLanguages) },
                    voiceTalentCount: { label: formatMessage(messages.numberOfVts) },
                    preferredLanguage: { label: formatMessage(messages.preferredLanguage) },
                    complex: { label: formatMessage(messages.complexOrder) },
                  }}
                  body={{
                    deal: (entry) => (
                      <Span>#{entry.order.deal_id} - {entry.order.name}</Span>
                    ),
                    customerName: Span,
                    priority: (entry) => (
                      priorityChip(entry.order.priority)
                    ),
                    deadline: (entry) => (
                      <DateSpan>{ entry.order.deadline || formatMessage(messages.notSetDeadline) }</DateSpan>
                    ),
                    languageCount: (entry) => (
                      <Span>{ entry.order.language_count || 0 } {formatMessage(messages.languageCountSpan)}</Span>
                    ),
                    voiceTalentCount: (entry) => (
                      <Span>{ entry.order.supplier_count || 0 } {formatMessage(messages.vtCountSpan)}</Span>
                    ),
                    preferredLanguage: (entry) => (
                      <Span>{ entry.language.name || '' }</Span>
                    ),
                    complex: (entry) => (
                      <Span>{ entry.order.complex ? formatMessage(messages.complexYesSpan) : formatMessage(messages.complexNoSpan) }</Span>
                    ),
                  }}
                  entries={handovers.filter((handover) => handover.order != undefined)}
                />
            </div>
          ))}
          <HandoverDetails handoverId={selectedHandoverId} onClose={() => setSelectedHandoverId(null)} />
        </>
      ) : (
        <div className='text-center'>
          <Heading>{formatMessage(messages.noHandoversAvailable)}</Heading>
        </div>
      )}
    </div>
  )
}

export default HandoverPage
